class RecentlyViewed extends HTMLElement {
  observer = undefined;
  swiper = undefined;

  constructor() {
    super();

    this.stack = JSON.parse(localStorage.getItem('viewedProducts'))?.filter(h => h !== this.dataset.handle) || [];

    if (this.dataset.maxItems && this.stack.length > this.dataset.maxItems) {
      this.stack = this.stack.slice(0, this.dataset.maxItems);
    }

    if (this.stack.length) {
      this.classList.remove('hidden'); 
      
      const wrapper = this.closest('div.no-js-hidden');
      if (wrapper) wrapper.classList.remove('hidden');
    }

    this.isMobile = window.innerWidth < 1024;
  }

  connectedCallback() {
    this.initializeRecentlyViewed();
  }

  initializeRecentlyViewed() {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver((entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.render();
    }, { rootMargin: '0px 0px 400px 0px' });
    this.observer.observe(this);
  }

  async render() {
    if (!this.stack.length) return;
    const request = this.getSanitazedUrl();
    const response = await fetch(request);
    const responseText = await response.text();
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const slides = html.querySelectorAll('[data-slide]');
    const wrapper = this.querySelector('[data-product-grid]');
    if (!wrapper || slides.length === 0) return;

    wrapper.classList.add('swiper-wrapper');
    wrapper.innerHTML = '';

    slides.forEach(slide => {
      wrapper.insertAdjacentHTML('beforeend', slide.outerHTML);
    });

    requestAnimationFrame(() => this.initSwiper());
  }

  initSwiper() {
    const waitForSwiper = (attempts = 0) => {
      if (typeof Swiper === 'undefined') {
        if (attempts > 30) {
          console.warn('Swiper non trovato — includi swiper-bundle.min.js prima di recently-viewed.js');
          return;
        }
        
        setTimeout(() => waitForSwiper(attempts + 1), 100);
        return;
      }

      if (this.swiper) {
        try { this.swiper.destroy(true, true); } catch (e) { /* ignore */ }
        this.swiper = undefined;
      }
  
      this.swiper = new Swiper('.recently-viewed-slider', {
        slidesPerView: 4,
        /*spaceBetween: 0,*/
          keyboard: {
              enabled: true,
          },
        navigation: {
          nextEl: ".recently-slider .swiper-button-next",
          prevEl: ".recently-slider .swiper-button-prev",
        },
        breakpoints: {
          320: {
              slidesPerView: 1.35,
              centeredSlides: true
              /*navigation: false,
              centeredSlides: true,
              pagination: {
                  el: ".product-recommendations .swiper-pagination",
                  type: "progressbar"
              },*/
          },
          750: { slidesPerView: 3 },
          991: { slidesPerView: 4 }
        }
      });
    };

    waitForSwiper();
  }

  getSanitazedUrl() {
    let request = '';
    for (let i = 0; i < this.stack.length; i++) request += '&rec_view=' + this.stack[i];
    const rootUrl = window.routes?.root_url || '';
    return `${location.origin + rootUrl}/search?q=${new Date().toString()}&view=recently-viewed${request}`;
  }
}

customElements.define('recently-viewed', RecentlyViewed);
